import styled from "styled-components";

const H1 = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 1.5rem;
`;

const Empty = styled.p`
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  font-size: 0.9375rem;
  margin: 0;
`;

export default function DashboardReviews() {
  return (
    <div>
      <H1>My Reviews</H1>
      <Empty>
        Store reviews are not available in your account yet. When we add review history, it will
        appear here.
      </Empty>
    </div>
  );
}
